<template>
<div class="modules">
    <div class="identification-container">
        <div class="summary">
            <h1 class="title">{{ $t("lang.Identification") }}</h1>
        </div>
        <!-- <div class="user">
            <el-avatar :size="50"></el-avatar>
            <div class="userinfo">
                <div class="username">Anonymous-User</div>
                <div class="status"></div>
            </div>
        </div> -->
        <div class="box-wrapper">
            <div class="box-main">
                <div class="mod">
                    <!-- <div class="hd">
                        <h3 class="title">Account Limits</h3>
                    </div> -->
                    <div class="bd">
                        <div class="unauthorized">
                            <div class="icon"></div>
                            <div class="text" v-if="userInfo && userInfo.auditState ==1 ">{{ $t("lang.authorized") }}</div>
                            <div class="text" v-else>{{ $t("lang.Unauthorized") }}</div>
                            <div class="action" v-if="!userInfo || userInfo.auditState ==2 " >
                                <el-button type="primary" round size="small" @click="openVerify">{{ $t("lang.authentication") }}</el-button>
                            </div>
                        </div>
                        <!-- <ul class="text-group">
                            <li>
                                <div class="text-item">
                                    <div class="item-label">Flat Deposit & Widthdrawal Limits</div>
                                    <div class="item-val">50K USD Daily</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">Crypto Deposit Limit</div>
                                    <div class="item-val">Unlimited</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">Crypto Widthdrawal Limit</div>
                                    <div class="item-val">8M BUSD Daily</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">
                                        P2P Transaction Limits
                                    </div>
                                    <div class="item-val">Unlimited</div>
                                </div>
                            </li>
                        </ul> -->
                    </div>
                </div>
                <div class="mod" v-if="userInfo">
                    <div class="hd">
                        <h3 class="title">{{ $t("lang.PersonalInformation") }}</h3>
                    </div>
                    <div class="bd">
                        <ul class="text-group">
                            <li>
                                <div class="text-item">
                                    <div class="item-label">{{ $t("lang.LegalName") }}</div>
                                    <div class="item-val">{{ userInfo.uname }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">{{ $t("lang.DateOfBirth") }}</div>
                                    <div class="item-val">{{ userInfo.birthday }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">{{ $t("lang.ideAddress") }}</div>
                                    <div class="item-val">{{ userInfo.address }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="text-item">
                                    <div class="item-label">
                                        {{ $t("lang.IdentificationNumber") }}
                                    </div>
                                    <div class="item-val">{{ userInfo.idNo }}</div>
                                </div>
                            </li>
                            <li>
                                <div class="cell-title">
                                    <div class="cell-icon">
                                        <img class="img" :src="api+userInfo.frontImg" />
                                        <div class="text">{{ $t("lang.frontIDCard") }}</div>
                                    </div>
                                    <div class="cell-info">
                                        <img class="img" :src="api+userInfo.backImg" />
                                        <div class="text">{{ $t("lang.ReverseIDCard") }}</div>
                                    </div>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            <!-- <div class="box-side">
                <div class="mod">
                    <div class="hd">
                        <h3 class="title">Verification Levels</h3>
                    </div>
                    <div class="bd">
                        <el-timeline class="level-list">
                            <el-timeline-item icon="el-icon-check" color="#44ac30">
                                <div class="timeline-item item-success">
                                    <div class="item-title">Verified</div>
                                    <div class="item-text">Flat Limit of 50K USD Daily</div>
                                    <div class="item-description">
                                        Verified:
                                        <ul class="item-metas">
                                            <li>Personal information</li>
                                            <li>Government-issued ID</li>
                                            <li>Facial recognition</li>
                                        </ul>
                                    </div>
                                </div>
                            </el-timeline-item>
                            <el-timeline-item>
                                <div class="timeline-item">
                                    <div class="item-title">Verified Plus</div>
                                    <div class="item-text">Flat Limit of 2M USD Daily</div>
                                    <div class="item-description">
                                        Required:
                                        <ul class="item-metas">
                                            <li>Rroof of address</li>
                                        </ul>
                                    </div>
                                </div>
                            </el-timeline-item>
                            <el-timeline-item>
                                <div class="timeline-item">
                                    <div class="item-title">Verified Plus</div>
                                    <div class="item-text">Unlimited Flat Transactions</div>
                                    <div class="item-description">
                                        Required:
                                        <ul class="item-metas">
                                            <li>Rroof of address</li>
                                            <li>Enhanced due dilligence</li>
                                        </ul>
                                    </div>
                                </div>
                            </el-timeline-item>
                        </el-timeline>
                    </div>
                </div>
            </div> -->
        </div>
        
    </div>
    <verify-dialog ref="verifyDialog" @reset="realNameDetail"></verify-dialog>
</div>
</template>
<script>
import VerifyDialog from './modules/verifyDialog.vue';
import {BASE_GLOB_API} from "@/config.js";
import {axiosGet, axiosPost} from '@/api/api';
export default {
    name:'identification',
    components:{VerifyDialog},
    data(){
        return {
            // Language: "en",
            api:BASE_GLOB_API,
            form:{
                uname:'',
                birthday:'',
                address:'',
                idNo:'',
                idType:1,
                backImg:'',
                frontImg:'',
            },
            url:{
                detail:BASE_GLOB_API+'/realName/detail',
                idCardPhoto:BASE_GLOB_API+'/realName/idCardPhoto',
                uploadIdCardImg:BASE_GLOB_API+'/realName/uploadIdCardImg',
            },
            userInfo:{},
            fileListA:[],
            fileListB:[],
            lang: "",
            minDate: new Date(1960, 0, 1),
            maxDate: new Date(2025, 10, 1),
        }
    },
    created(){
      this.lang = sessionStorage.getItem("Language")
      this.realNameDetail()
    },
    methods:{
        realNameDetail(){
            let params =''
                
            axiosGet(this.url.detail,params).then(res=>{
            if(res.success){
                this.userInfo = res.result
            //   this.$message.success(res.message);
            }else{
                this.$message.error(res.message);
            }

            })
            },
        handleChange() {
            this.$i18n.locale = this.Language;
            sessionStorage.setItem("Language", this.Language);
        },
        openVerify(){
            if(this.userInfo){
                this.$refs.verifyDialog.open(this.userInfo);
            }else{
                this.$refs.verifyDialog.open();
            }

        },
    }
}
</script>
<style lang="less" scoped>
.identification-container {
    .summary {
        background:#f4f5f6; border-radius:4px; padding:30px; display:flex; justify-content: space-between; align-items: center; margin-bottom:30px;
    }
    .user {
        display:flex; justify-content: flex-start; align-items: center; padding:0 0 30px; border-bottom:#e6e6e6 1px solid;
        .userinfo {
            flex:1; padding:0 0 0 15px;
            .username {
                font-weight:700; font-size:16px;
            }
        }
    }
    .box-wrapper {
        display:flex; justify-content: space-between; align-items: flex-start; padding:30px 0 0;
        .mod {
            margin-bottom:20px; 
            .hd {
                padding:10px 0;
                .title {
                    font-size:16px; font-weight:700;
                }
            }
            .bd {
                .text-group {
                    .text-item {
                        padding:5px 0; display:flex; justify-content: space-between; align-items: center;
                        .item-label {
                            color:#666;
                        }
                        .item-val {
                            color:#333; font-weight:700;
                        }
                    }
                    .cell-title{
                            display: flex;
                            justify-content: space-around;
                            padding-top: 30px;
                        .cell-icon{
                            width: 45%;
                            height: 150px;
                            text-align: center;
                            .img{
                                height: 120px; 
                            }
                            .text{
                                text-align: center;
                            }
                        }
                        .cell-info{
                            width: 45%;
                            height: 150px;
                           text-align: center;
                            .img{
                                height: 120px; 
                            }
                            .text{
                                text-align: center;
                            }
                        }
                    }
                }
                ::v-deep .level-list {
                    .el-timeline-item {
                        .el-timeline-item__node {
                            width:20px; height:20px; left:-5px;
                        }
                    }
                    .timeline-item {
                        padding:4px 0 0;
                        .item-title {
                            color:#666; font-weight:700;
                        }
                        .item-text {
                            font-weight:700;
                        }
                        .item-description {
                            padding:10px 0 10px; color:#666;
                            .item-metas {
                                margin:4px 0 0 20px;
                                &>li {
                                    list-style-type: disc;
                                }
                            }
                        }
                        &.item-success {
                            .item-title {
                                color:#44ac30;
                            }
                        }
                    }
                }
            }
        }
        .box-main {
            flex:1;
            .mod {
                padding-bottom:20px; border-bottom:#e6e6e6 1px solid;
                &:last-child {
                    border-bottom:0;
                }
            }
        }
        .box-side {
            width:280px; min-width:280px; margin-left:100px;
        }
    }
}
.unauthorized {
    text-align:center; padding:30px;
    .icon {
        background:url('~@/assets/img/status_identification.svg') no-repeat center center/contain; width:64px; height:64px; margin:0 auto 5px;
    }
    .text {font-size:14px; color:#999; padding:0 0 15px;}
}
</style>